'use client'

import { usePathname } from 'next/navigation'
import { Alert, Button, Container, Icon, Typography } from '@shc/ui'

interface AlertSpoofingProps {
  spoofedName: any
}

const AlertSpoofing = ({
  spoofedName,
}: AlertSpoofingProps) => {
  const pathname = usePathname()

  return (
    pathname.includes('/providers') && (
      <Container className="mt-3">
        <Alert
          className="justify-between sm:py-2"
          severity="error">
          <div className="hidden sm:flex" />{/* Pseudo-column to keep icon and name centered */}

          <div className="flex sm:items-center">
            <p>{/* Vertically aligns icon at xs viewport widths */}
              <Icon
                className="mr-2"
                icon="eye"
              />
            </p>

            <Typography>
              Spoofing {spoofedName}
            </Typography>
          </div>

          <div>
            <Button
              aria-label="Unspoof"
              color="light"
              onClick={() => window.location='/custom-api/admin/endspoof'}
              size="xs"
              width="auto">
              <Typography className="!text-gray-700">
                Unspoof
              </Typography>
            </Button>
          </div>
        </Alert>
      </Container>
    )
  )
}

export default AlertSpoofing
